<template>
  <div class="svgicon" :class="{ scale: !!width || !!height }" @click="$emit('click')"
    :style="{ width: width + 'px', height: height + 'px' }"></div>
</template>

<script>
  let svgcache = new Map();

  export default {

    props: ["src", "width", "height"],

    mounted() {
      this.templateSVG();
    },

    watch: {
      src: function () {
        this.templateSVG();
      }
    },

    methods: {
      async templateSVG() {
        let svg;
        let cached = svgcache.get(this.src);
        if (cached) {
          if (cached.svg) {
            svg = cached.svg;
          } else {
            cached.queue.push(this);
            return;
          }
        } else {
          svgcache.set(this.src, {
            svg: null,
            queue: []
          });
          svg = await fetch(this.src).then(r => r.text());
          cached = svgcache.get(this.src);
          cached.svg = svg;
          cached.queue.forEach(q => q.templateSVG());
          cached.queue = [];
        }
        if (svg.indexOf("<html>") == -1) {
          this.$el.innerHTML = svg;
        } else {
          this.$el.innerHTML = "";
        }
      }
    }

  }
</script>

<style lang="scss">
  .svgicon {
    display: flex;
    justify-content: center;
    align-items: center;

    &.scale svg {
      width: 100%;
      height: 100%;
    }
  }
</style>